import React, { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FaArrowLeft, FaEdit, FaTrash } from "react-icons/fa";
import { SettingGeneralProvider } from "../../../../context/settingGeneralContext";
import TableReusable from "../../../Global/Table";
import { useNavigate } from "react-router-dom";
import { API } from "../../../../config/api";
import swal from "sweetalert";
import LoaderHome from "../../../Loader/LoaderHome"


export default function FormEditTreatment({
    GetResponseDataTreatmentCategory,
    treatment,
    rows,
    page,
    pages,
    changePage,
    msg,
    onBack,
}) {
    return (
        <SettingGeneralProvider>
            <FormEditTreatmentContent
                GetResponseDataTreatmentCategory={GetResponseDataTreatmentCategory}
                treatment={treatment}
                rows={rows}
                page={page}
                pages={pages}
                changePage={changePage}
                msg={msg}
                onBack={onBack}
            />
        </SettingGeneralProvider>
    );
}

function FormEditTreatmentContent({
    GetResponseDataTreatmentCategory,
    treatment,
    rows,
    // page,
    pages,
    changePage,
    // msg,
    onBack,
    viewModalUpdate,
    deleteById,
}) {
    const getRowNumber = (index) => (page - 1) * 10 + index + 1;


    console.log(treatment?.id_category)
    const navigate = useNavigate();
    const [getData, setGetData] = useState([]);
    // const [page, setPage] = useState(1);
    const [limit] = useState(10);
    // const [pages, setPages] = useState();
    const [ascending] = useState(0);
    // const [rows, setRows] = useState(1);
    const [keyword, setKeyword] = useState("");
    const [query, setQuery] = useState("");
    // const [msg, setMsg] = useState("");
    const [page, setPage] = useState(1);
    const [msg, setMsg] = useState("");

    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(false);





    let fetchParams = {
        headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
    };


    const [form, setForm] = useState({
        name: treatment?.name || "",
        id_category: treatment?.id_category || "",
    });




    const GetResponseData = async () => {
        try {
            setLoading(true)
            const response = await API.get(`transaction-service/treatment-categories?page=${page}&limit=1000000&ascending=${ascending}&search=${keyword}`, fetchParams)
            // Checking process
            if (response?.status === 200) {
                setGetData(response.data.data)
                // setPage(response.data.pagination.current_page);
                // setPages(response.data.pagination.total_pages);
                // setRows(response.data.pagination.total);
                setLoading(false)
            }
        } catch (error) {
            if (error.response.status === 401) {
                navigate('/dashboard')
                swal({
                    title: 'Failed',
                    text: `Akses dibatasi Tidak Dapat Mengakses Halaman Ini`,
                    icon: 'error',
                    timer: 3000,
                    buttons: false
                });
            } else {
                swal({
                    title: 'Failed',
                    text: `${error.response.data.message}`,
                    icon: 'error',
                    timer: 3000,
                    buttons: false
                });
                setLoading(false)
            }
        }
    }


    const handleSubmit = async () => {
        if (!form.id_category) {
            swal({
                title: "Warning",
                text: "Kategori harus dipilih!",
                icon: "warning",
                timer: 2000,
                buttons: false,
            });
            return;
        }

        try {
            setLoading(true);
            const response = await API.put(
                `transaction-service/treatments/${treatment.id}`,
                {
                    name: form.name,
                    id_category: form.id_category,
                },
                fetchParams
            );

            if (response?.status === 200) {
                swal({
                    title: "Berhasil!",
                    text: "Data treatment berhasil diperbarui.",
                    icon: "success",
                    timer: 2000,
                    buttons: false,
                });
                GetResponseDataTreatmentCategory()
                onBack();
            }
        } catch (error) {
            swal({
                title: "Gagal",
                text: `${error.response?.data?.message || "Update gagal"}`,
                icon: "error",
                timer: 3000,
                buttons: false,
            });
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        GetResponseData()
    }, [page])

    const searchData = (e) => {
        e.preventDefault();
        setPage(0);
        setMsg("");
        setKeyword(query);
    };

    return (
        <>
            {loading && <LoaderHome />}
            <div className="container mt-3">
                <div className="row">
                    <div className="col-md-12 d-flex gap-2">
                        <div>Nama Treatment:</div>
                        <div><span style={{ fontWeight: "bold" }}> {treatment?.name || "-"}</span></div>
                    </div>
                </div>
                <div className="row mt-3" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div></div>

                    <div style={{ fontWeight: "bold" }}>Kategori:</div>
                    <div>
                        <select
                            className="form-select"
                            name="id_category"
                            value={form.id_category}
                            onChange={(e) =>
                                setForm({ ...form, id_category: e.target.value })
                            }
                            style={{ cursor: "pointer", fontSize: "13px" }}
                        >
                            <option value="" hidden>
                                Pilih Kategori
                            </option>
                            {getData.map((user) => (
                                <option key={user?.id} value={user?.id}>
                                    {user?.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="d-flex justify-content-end align-items-center gap-3 mt-3">
                    <button
                        type="button"
                        className="btn btn-sm btn-info text-light"
                        onClick={onBack}
                    >
                        Kembali
                    </button>

                    <button
                        type="button"
                        className="btn btn-sm btn-primary text-light"
                        onClick={handleSubmit}
                    >
                        Simpan
                    </button>
                </div>


            </div>

        </>
    );
}
